<template>
  <div class="dashboard-profile">
    <div class="dashboard-profile-image">
      <img :src="profile.avatar || $avatars[profile.defaultAvatarId || 13]" alt="avatar">
    </div>
    <div class="dashboard-profile-name">
      {{profile.kidName || 'Kid'}}
    </div>
    <div class="dashboard-profile-status">
      <div class="dashboard-profile-status-active" v-if="activeProfiles[index] && profile.dailyLimitUsed < profile.todayDailyLimit && !isUnAvailableTime">
        {{$lang.messages.dashboard.profile.active_now}} {{activeProfiles[index].deviceName}}
      </div>
      <template v-else>
        <div class="dashboard-profile-status-over" v-if="profile.dailyLimitUsed >= profile.todayDailyLimit || isUnAvailableTime">
          {{$lang.messages.dashboard.profile.time_over}}
        </div>
        <div class="dashboard-profile-status-offline" v-else>
          {{$lang.messages.dashboard.profile.offline_now}}
        </div>
      </template>
    </div>
    <div class="dashboard-profile-footer">
      <div v-if="profile.startSessionTime" class="dashboard-profile-start-session">
        Session started {{formatAMPM(profile.startSessionTime)}}
      </div>
      <div class="progress w-100 mb-2" v-if="profile.todayDailyLimit < 86400">
        <div class="progress-label" v-if="profile.todayDailyLimit < 86400">
          <span class="text-bold text-md">{{ Math.floor(profile.dailyLimitUsed / 60) }}</span>
          <span class="text-thin">m</span>
        </div>
        <div class="progress-label" v-if="profile.todayDailyLimit < 86400">
          <span class="text-bold text-md">{{ Math.floor((profile.todayDailyLimit || profile.dailyLimit) / 60) }}</span>
          <span class="text-thin">m</span>
        </div>
        <div class="progress-percent" v-if="profile.todayDailyLimit < 86400" :style="{width: profile.dailyLimitUsed / profile.todayDailyLimit * 100 +'%'}"></div>
      </div>
      <div class="progress profile-unlimited" v-else>{{$lang.messages.dashboard.profile.unlimited}}</div>
      <LockDeviceSwitcher v-if="activeProfiles[index]" :deviceID="activeProfiles[index].deviceID" @togglekidsmode="sendToggleKidsModeEvent"/>
      <div @click="openProfile(index)" class="btn btn-main -shadow" v-else>
        {{$lang.messages.dashboard.profile.view_profile}}
      </div>
    </div>
  </div>
</template>

<script>

import {formatAMPM, isProfileTimeUnAvailable} from '../helpers/utils'
import LockDeviceSwitcher from "@/components/LockDeviceSwitcher";

export default {
  name: 'DashboardProfile',
  props: ['index', 'profile', 'activeProfiles'],
  methods: {
    formatAMPM,
    openProfile(index){
      this.$router.push({path: 'profile', query: {id: index}})
    },
    sendToggleKidsModeEvent(deviceID, newSetting){
      this.$emit('toggle-kids-mode', deviceID, newSetting)
    },
  },
  components: {
    LockDeviceSwitcher
  },
  computed: {
    isUnAvailableTime() {
      return isProfileTimeUnAvailable(this.profile.availableTime);
    }
  }
}

</script>